import React from 'react';
import PropTypes from 'prop-types';
import { InputNumber as AntInputNumber } from 'antd';
import './styles.less';

const InputNumber = ({ hideArrows, className, style, ...props }) => {
  const updatedClassName = `${className} ${hideArrows ? 'input-number--no-arrows' : ''}`;

  const customStyle = {
    width: '100%',
    ...style,
  };

  return <AntInputNumber style={customStyle} className={updatedClassName} {...props} />;
};

InputNumber.propTypes = {
  hideArrows: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.shape(),
};

InputNumber.defaultProps = {
  hideArrows: undefined,
  className: undefined,
  style: undefined,
};

export default InputNumber;
